export class Data {
    id: number;
    occName: string;
}

export class Occupation {
    id: number;
    occName: string;
}

export class DialogData {
    type: number;
    width: string;
    height: string;
    minWidth?: string;
    classNameObtained: string;
    dataInfo: object;

}

export class UrlEnv {
    mainConfig: 'assets/config.json';
    quotesConfig: 'configuration/config.json';
}

// Radio

export class RadioEventData {
    name: string;
    value: string | number;
}


// Edit quote modal
export class EditQuoteModalData {
    gender: Gender;
    smoke: Smoke;
    dob: Date;
    annualIncome: string;
}

// Radio list
export class RadioList {
    name: string;
    value: string | number;
}

// Gender

export class Gender {
    name: string;
    value: string | number;
}

// Smoke
export class Smoke {
    name: string;
    value: string | number;
}


export class AnnualIncome {
    name: string;
    type: number;
    class: string;
    defualt: number;
    order: number;
    label: string;
    outlineFormField: string;
    required: boolean;


}

// Component load

export class BiComponentData {
    data: any;
}

export class LimitedComponentData {
    data: any;
}

export class LifeProposalComponentData {
    data: any;
}

export class LifeCommunicationComponentData {
    data: any;
}


export class LifeStyleComponentData {
    data: any;
}

export class LifeHealthComponentData {
    data: any;
}

export class LifeNomineeComponentData {
    data: any;
}

export class LifeBankComponentData {
    data: any;
}
export class LifePrvPolicyComponentData {
    data: any;
}

export class LifeDocumnetComponentData {
    data: any;
}

export class LifeQuestion {
    data: any;
}

export class LifeAcr {
    data: any;
}

export class CountryInfo {
    // tslint:disable-next-line: variable-name
    master_name: string;
    id: number;
}

export class IfscInfo {
    // tslint:disable-next-line: variable-name
    ifsc_code: string;
    branch_name: string;
    branch_address: string;
    id: number;
}


export class CompanyInfo {
    // tslint:disable-next-line: variable-name
    master_name: string;
    id: number;
}
